import React, { Component } from 'react';
import './AssignSOP/css/AssignSOP.css'
import { DialogMessage } from './Widgets/DialogMessage';
import { Loader } from './Widgets/Loader';

export default class AssignSOP extends Component {
    constructor(props) {
        super(props);
        this.state = {
            message: null,
            toteNum: "",
            SONum: "",
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: false
        };
        this.refreshState = this.refreshState.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.updateToteNum = this.updateToteNum.bind(this);
        this.updateSONum = this.updateSONum.bind(this);
        this.startLoading = this.startLoading.bind(this);
        this.stopLoading = this.stopLoading.bind(this);
        this.assignSO = this.assignSO.bind(this);
        this.assignSOCallback = this.assignSOCallback.bind(this);
        
    }

    componentDidMount() {
        var toteInput = document.getElementById('assign-tote-input');
        var SOInput = document.getElementById('assign-so-input');
        var submitButton = document.getElementById('assign-so-submit');
        //when enter is pressed on the tote input, move to the slot input
        toteInput.addEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                if (!SOInput.value) {
                    SOInput.focus();
                }
                else {
                    submitButton.click();
                }
            }
        });

        SOInput.addEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                if (!toteInput.value) {
                    toteInput.focus();
                }
                else {
                    submitButton.click();
                }
            }
        });
    }

    refreshState() {
        this.setState({
            message: null,
            toteNum: "",
            SONum: "",
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: false
        });
        
    }

    closeDialog() {
        this.setState({
            showDialog: false,
            dialogFullScreen: false,
            dialogContent: "",
            dialogTitle: "",
            isErrorMessage: false
        });
    }


    updateToteNum(inputValue) {
        this.setState({
            toteNum: inputValue
        });
    }

    updateSONum(inputValue) {
        this.setState({
            SONum: inputValue.toUpperCase()
        });
    }

    startLoading() {
        this.setState({
            loading: true
        });
    }

    stopLoading() {
        this.setState({
            loading: false
        });
    }

    assignSO() {
        this.startLoading();
        this.assignSOCallback();
    }

   async assignSOCallback() {
        var putBody = {
            SONum: this.state.SONum,
            toteId: this.state.toteNum
       };
       await this.props.makeRESTCall(
           'byuassignsop',
           'put',
           putBody,
           (assignSOPData) => {
               var dialogContent;
               var dialogTitle;
               var isErrorMessage = false;
               if (assignSOPData.success) {
                   dialogContent = this.state.SONum + ' was succesfully added to tote ' + this.state.toteNum;
                   dialogTitle = "SO Successfully Assigned"
               }
               else {
                   isErrorMessage = true;
                   dialogContent = assignSOPData.errMessage;
                   dialogTitle = "Error Assigning SO"
               }
               this.setState({
                   dialogTitle: dialogTitle,
                   dialogContent: dialogContent,
                   showDialog: true,
                   loading: false,
                   isErrorMessage: isErrorMessage,
                   SONum: "",
                   toteNum: ""
               });
           },
           (title, error) => {
               console.error('Error:', error);
               this.setState({
                   dialogTitle: title,
                   dialogContent: error,
                   showDialog: true,
                   loading: false,
                   isErrorMessage: true,
                   SONum: "",
                   toteNum: ""
               });
           },
           () => {
               this.stopLoading();
           }
       );
    }

    render() {
        return (
            <div>
                <DialogMessage
                    closeDialog={this.closeDialog}
                    showDialog={this.state.showDialog}
                    dialogTitle={this.state.dialogTitle}
                    dialogContent={this.state.dialogContent}
                    isErrorMessage={this.state.isErrorMessage}
                    dialogFullScreen={this.state.dialogFullScreen}
                />
                {
                    this.state.loading && <Loader />
                }
                <h1 className='assign-so-title'>Assign SO to Tote</h1>
                <br />
                <h1 className='assign-so-subtitle'>Insert SO Number</h1>
                <input autoFocus onChange={(event) => this.updateSONum(event.target.value)} value={this.state.SONum} id='assign-so-input' className='assign-so-input'></input>
                <h1 className='assign-so-subtitle'>Insert Tote ID</h1>
                <input onChange={(event) => this.updateToteNum(event.target.value)} value={this.state.toteNum} id='assign-tote-input' className='assign-so-input'></input>
                <button onClick={(event) => this.assignSO()} id='assign-so-submit' className='assign-so-submit'>Submit</button>
            </div>
        );
    }
}
